<template>
  <section class="page-container">
    <div
      class="filter-bar"
      :class="{
        'blue-bg': diff,
        'border-bottom-radius': !showFilterCard}">
      <div class="main-left">
        <div class="left">
          <font-awesome-icon
            icon="filter"
            class="icon icon-filter"></font-awesome-icon>
          <span class="text">Filter</span>
        </div>
        <div class="filter-status">
          <span
            v-for="(item, i) in statusList"
            :key="i"
            class="status-item">
            <span class="status-title">
              {{item.title}}:
            </span>
            <span class="content">
              {{item.content}}
            </span>
          </span>
        </div>
      </div>
      <div class="right">
        <div
          v-if="diff"
          class="translucence"></div>
        <div class='right-content'>
          <font-awesome-icon
            v-show="diff"
            icon="rotate-left"
            class="icon icon-rotate pointer"
            @click="resetFilter"></font-awesome-icon>
          <font-awesome-icon
            v-if="showFilterCard"
            icon="square-minus"
            class="icon pointer"
            @click="showFilterCard = false"></font-awesome-icon>
          <font-awesome-icon
            v-else
            icon="square-plus"
            class="icon pointer"
            @click="showFilterCard = true"></font-awesome-icon>
        </div>
      </div>
    </div>
    <div
      v-show="showFilterCard"
      class="filter-card border-bottom-radius">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Referrered by</span>
            <v-input
              v-model="referrer_code"
              @change="filterData"></v-input>
          </div>
          <div class="form-item">
            <span>Referrer's sign up Referrer </span>
            <v-input
              v-model="referrer_referrer_code"
              @change="filterData"></v-input>
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Tags
              <span
                class="all"
                @click="handlerSelectAll('tags')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('tags')">None</span>            </span>
            <div class="flex-column">
              <v-checkbox
                v-model="tier_base"
                :isBoolean="false"
                class="diamond-status"
                @change="filterData"
              >Professional</v-checkbox>
              <v-checkbox
                v-model="is_blocked"
                :isBoolean="false"
                class="blocked-status"
                @change="filterData"
              >Blocked</v-checkbox>
            </div>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('status')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('status')">None</span>            </span>
            <v-checkbox-group
              v-model="status"
              :list="userStatusOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-status"
                    :class="{
                      'red': item.id == 0,
                      'green': item.id == 1
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div class="filter-last">
          <div class="form-item">
            <span>
              Marketing Communication
            </span>
            <div class="flex-column">
              <v-checkbox
                v-model="is_comm_sub"
                :isBoolean="false"
                class="diamond-status gray"
                @change="filterData"
              >Receive</v-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'">
        <el-table-column
          width="10"
        >
        </el-table-column>
        <el-table-column
          prop="id"
          width="45"
        >
          <template #default="{row}">
            <font-awesome-icon
              :class="{'orange': row.is_flagged}"
              :icon="row.is_flagged? 'person-circle-exclamation' : 'user'" />
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span  class="color-dark">{{ row.created_at.split(" ")[0] }}</span><br>
              <span  class="color-dark"> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          label="Name">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="first-text weight-text">
                {{ row.isrd_nm != ' '? row.isrd_nm : 'Unnamed Account'}}
              </span>
              <p class="liter-text">#{{ row.id }}</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Tel/email">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="first-text">
                {{ row.registered_login}}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Referrered by">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.referrer_isrd_nm }}</span>
              <p class="liter-text">{{row.referrer_code }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="130px"
          label="Total No. of Policy">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">{{ row.total_policy_num }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Total GWP">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text ">{{ row.total_gross | formatMoney(2,true) }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Total Payable">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">{{ row.total_amount | formatMoney(2,true) }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="130px"
          label="No. of Referred">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="liter-text">New Member</p>
              <p class="first-text weight-text">{{ row.referrer_agent_num }} </p>

              <p class="liter-text">Policy</p>
              <p class="first-text weight-text">{{ row.referrer_policy_num }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="130px"
          label="Hold Dollars">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="liter-text">Total Rewarded</p>
              <p class="first-text weight-text">{{ row.recommend_hollars | formatMoney(2,true) }} </p>

              <p class="liter-text">Current</p>
              <p class="first-text weight-text">{{ row.all_hollars | formatMoney(2,true) }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="190px"
          label="Marketing Communication"
          prop="referrer_nm">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">
                {{ row.marketing_communications }}
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinMarketing from '@/mixins/marketing'


export default {
  name: 'clientProfile',
  mixins: [MixinMarketing],
  props:{
    isFulfilled:{
      type:Boolean,
      default:false
    },
    isList:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      date: [],
      referrer_code: '',
      stts: [],
      statusList: [],
      showFilterCard: true,
      tier_base: 0,
      is_blocked: 0,
      type:[],
      status:[],
      referrer_referrer_code:'',
      is_comm_sub:0,
      is_client:1,
      defaultFilter:{
        date: [],
        stts: [],
        type:[],
        tier_base: 0,
        is_blocked: 0,
        referrer_code:'',
        referrer_referrer_code:'',
        status:[],
        is_client:1,
        is_comm_sub:0,
      },
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/marketing/marketing';

</style>
